"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosLotteryTicketSaleUpdateInputSchema = exports.APosLotteryQuickPickInputSchema = exports.APosLotteryDrawGameSaleInputSchema = exports.APosLotteryScratchOffSaleInputSchema = exports.APosLotteryTicketSaleSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const lottery_game_schema_1 = require("./lottery-game.schema");
exports.APosLotteryTicketSaleSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    saleId: id_schema_1.EntityIdSchema,
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: lottery_game_schema_1.APosLotteryGameCategorySchema,
    // Scratch-off only
    bookId: zod_1.z.string().optional(),
    ticketNumber: zod_1.z.string().optional(),
    serialNumber: zod_1.z.string().optional(),
    // Draw game fields
    selectedNumbers: zod_1.z.array(zod_1.z.number().int()).optional(),
    isQuickPick: zod_1.z.boolean().optional(),
    drawDate: zod_1.z.string().optional().describe('ISO date string for the draw'),
    numberOfDraws: zod_1.z.number().int().min(1).default(1),
    bonusNumber: zod_1.z.number().int().optional(),
    // Common
    salePrice: zod_1.z.number().int().min(0).describe('Sale price in cents'),
    locationId: id_schema_1.EntityIdSchema,
    employeeId: zod_1.z.string().optional(),
    posTransactionId: zod_1.z.string().optional(),
    soldAt: zod_1.z.string().describe('ISO datetime string'),
    isWinner: zod_1.z.boolean().default(false),
    prizeAmount: zod_1.z.number().int().min(0).optional().describe('Prize amount in cents'),
    prizePaidAt: zod_1.z.string().optional(),
    prizePaidBy: zod_1.z.string().optional(),
    isVoided: zod_1.z.boolean().default(false),
    voidedAt: zod_1.z.string().optional(),
    voidedBy: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosLotteryScratchOffSaleInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: zod_1.z.literal('scratch_off'),
    bookId: zod_1.z.string().min(1),
    ticketNumber: zod_1.z.string().min(1),
    serialNumber: zod_1.z.string().optional(),
    salePrice: zod_1.z.number().int().min(0),
    locationId: id_schema_1.EntityIdSchema,
    employeeId: zod_1.z.string().optional(),
    posTransactionId: zod_1.z.string().optional(),
    soldAt: zod_1.z.string(),
});
exports.APosLotteryDrawGameSaleInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: zod_1.z.literal('draw_game'),
    selectedNumbers: zod_1.z.array(zod_1.z.number().int()).min(1),
    isQuickPick: zod_1.z.boolean().default(false),
    drawDate: zod_1.z.string(),
    numberOfDraws: zod_1.z.number().int().min(1).optional(),
    bonusNumber: zod_1.z.number().int().optional(),
    salePrice: zod_1.z.number().int().min(0),
    locationId: id_schema_1.EntityIdSchema,
    employeeId: zod_1.z.string().optional(),
    posTransactionId: zod_1.z.string().optional(),
    soldAt: zod_1.z.string(),
});
exports.APosLotteryQuickPickInputSchema = zod_1.z.object({
    gameId: id_schema_1.EntityIdSchema,
    gameCategory: zod_1.z.literal('draw_game'),
    drawDate: zod_1.z.string(),
    numberOfDraws: zod_1.z.number().int().min(1).optional(),
    salePrice: zod_1.z.number().int().min(0),
    locationId: id_schema_1.EntityIdSchema,
    employeeId: zod_1.z.string().optional(),
    posTransactionId: zod_1.z.string().optional(),
    soldAt: zod_1.z.string(),
});
exports.APosLotteryTicketSaleUpdateInputSchema = zod_1.z.object({
    isWinner: zod_1.z.boolean().optional(),
    prizeAmount: zod_1.z.number().int().min(0).optional(),
    prizePaidAt: zod_1.z.string().optional(),
    prizePaidBy: zod_1.z.string().optional(),
    isVoided: zod_1.z.boolean().optional(),
    voidedAt: zod_1.z.string().optional(),
    voidedBy: zod_1.z.string().optional(),
});
//# sourceMappingURL=lottery-ticket-sale.schema.js.map